import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { Skeleton } from 'antd';
import { useEffect, useState } from 'react';
import { userApi } from './api/user';
import Login from './pages/Login';
import MainLayout from './layouts/MainLayout';
// 假设后续会创建这些页面
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Register from './pages/Register';
import NotFound from './pages/NotFound';
import Patients from './pages/Patients';
import TreatmentRecords from './pages/TreatmentRecords';
import ScheduleTemplates from './pages/ScheduleTemplates';
import Schedules from './pages/Schedules';
import Appointments from './pages/Appointments';
import ScheduleLocations from './pages/ScheduleLocations';
import CustomEnumManagement from './pages/CustomEnumManagement';

// 私有路由组件，需要登录才能访问
const PrivateRoute: React.FC = () => {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isAuthenticated = await userApi.checkSession();
        setAuthenticated(isAuthenticated);
      } catch (error) {
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return <Skeleton active />;
  }

  return authenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

// 路由配置
const routes = [
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/',
    element: <PrivateRoute />,
    children: [
      {
        path: '/',
        element: <Navigate to="/dashboard" replace />
      },
      {
        path: 'dashboard',
        element: (
          <MainLayout>
            <Dashboard />
          </MainLayout>
        )
      },
      {
        path: 'profile',
        element: (
          <MainLayout>
            <Profile />
          </MainLayout>
        )
      },
      {
        path: 'patients',
        element: (
          <MainLayout>
            <Patients />
          </MainLayout>
        )
      },
      {
        path: 'patients/:patientId/treatment-records',
        element: (
          <MainLayout>
            <TreatmentRecords />
          </MainLayout>
        )
      },
      {
        path: 'schedule-templates',
        element: (
          <MainLayout>
            <ScheduleTemplates />
          </MainLayout>
        )
      },
      {
        path: 'schedules',
        element: (
          <MainLayout>
            <Schedules />
          </MainLayout>
        )
      },
      {
        path: 'appointments',
        element: (
          <MainLayout>
            <Appointments />
          </MainLayout>
        )
      },
      {
        path: 'schedule-locations',
        element: (
          <MainLayout>
            <ScheduleLocations />
          </MainLayout>
        )
      },
      {
        path: 'custom-enum-management',
        element: (
          <MainLayout>
            <CustomEnumManagement />
          </MainLayout>
        )
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;